import React from 'react';
import makeStyles from "@material-ui/core/styles/makeStyles";
import StepLabel from "@material-ui/core/StepLabel";
import Step from "@material-ui/core/Step";
import Stepper from "@material-ui/core/Stepper";
import {useTranslation} from 'react-i18next';
import ChooseProfession from './steps/ChooseProfession/ChooseProfession'
import useMediaQuery from '@material-ui/core/useMediaQuery';
import PersonalDetails from "./steps/PersonalDetails/PersonalDetailsStep";
import DefineTimeOff, {defaultEvents} from "./steps/DefineTimeOff/DefineTimeOff";
import {registerOrUpdateSupplier} from "../../api";
import CheckCircleOutlineTwoToneIcon from '@material-ui/icons/CheckCircleOutlineTwoTone';
import {Link, useHistory} from "react-router-dom";
import Button from "@material-ui/core/Button";
import useTheme from "@material-ui/core/styles/useTheme";
import {ADD_NOTIFICATION, AUTH_SUCCESSFUL} from "../../store/action";
import {connect} from "react-redux";
import CopyLinkToClipboard from "../CopyLinkToClipboard";
import useWizard from "../../hooks/useWizard";
import MoreDetails from "./steps/MoreDetails/MoreDetails";
import {getSupplierDataAction} from "../../store/actionCreators";
import withStyles from "@material-ui/core/styles/withStyles";
import imageUrl from "../../assets/background-image.jpg";
import SeoComp from "../SeoComp";
import firebase from "firebase/compat/app";

const useStyles = makeStyles((theme) => {
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
        },
        button: {
            marginRight: theme.spacing(1),
        },
        instructions: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
        },
        successMessage: {
            height: '500px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
        },
        section: {
            margin: '40px 0',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        bigGreenText: {
            fontSize: '40px',
            color: theme.palette.success.main
        }


    }
});

const StyledStepper = withStyles((theme)=>({
    root: {
        padding: '12px',
        backgroundColor: theme.palette.background.default,
    },
}))(Stepper);

function useGetSteps(editMode) {
    const {t} = useTranslation();
    if (!editMode) {
        return [{name: t('personal_details')}, {name: t('profession')}, {name: t('more_info')}]
    }
    return [{name: t('personal_details')}, {name: t('profession')}, {name: t('more_info')}, {name: t('business_hours')}];
}

export const defaultValues = {
        activities: [{}],
        workingAbility: defaultEvents,
        images: [],
        cities: [],
        allowPayments: false
    }
const signupSupplierWizardKey = 'signupSupplierWizardStep'
const SighupSupplierWizard = (props) => {
    const {dispatch, editMode, auth, supplier, getSupplierData} = props;
    const classes = useStyles();
    const steps = useGetSteps(editMode);
    const {t} = useTranslation();
    const theme = useTheme()
    const isDesktop = useMediaQuery(theme.breakpoints.up('lg'))
    const history = useHistory()
    const {activeStep, handleNext, handleBack, gotoStep} = useWizard({localStorageKey: signupSupplierWizardKey, runOnNext:(values)=>{
            // sessionStorage?.setItem(signupSupplierWizardKey+'_values',JSON.stringify(values))
    }
    })
    // const sessionStorageInitialValues = useMemo(()=>JSON.parse(sessionStorage?.getItem(signupSupplierWizardKey+'_values')),[])
    // useEffect(()=>{
    //     return ()=>{
    //         sessionStorage?.removeItem(signupSupplierWizardKey+'_values')
    //     }
    // },[])

    const {personalData: {_id, email, description, fullName, images, phone, professionId, businessHours, address, shortHash, cities, allowPayments = false, paymentId, allowMultipleServices}, activities} = supplier || {personalData: {}};
    const initialValues = editMode ? {
        auth,
        fullName,
        email,
        description,
        phone,
        profession: {_id: professionId, heName: null},
        activities: activities?.length !== 0 ? activities?.map(({subProfessionId: subProfession, ...rest}) => ({...rest, subProfession})) : [{}],
        workingAbility: businessHours,
        supplierId: _id,
        address,
        images: images || [],
        cities: cities || [],
        allowPayments,
        allowMultipleServices,
        paymentId,
        shortHash
    } : defaultValues
    const readyToRender = (email && editMode) || !editMode

    const onSubmit = (values, dis, props) => {
        registerOrUpdate(values,props)
    }
    const registerOrUpdate = async (values,props) => {
        const idToken = await firebase.auth().currentUser.getIdToken(/ forceRefresh / )
        registerOrUpdateSupplier({...values,auth:idToken}).then(async ({data: {shortHash}}) => {
            props.destroy()
            if (editMode) {
                dispatch({
                    type: ADD_NOTIFICATION,
                    payload: {
                        type: 'success',
                        text: t('updated_successfully')
                    }
                })  
                     getSupplierData(auth)
                history.push("/calendar")
            }
        }).catch((e)=>{
            dispatch({
                type: ADD_NOTIFICATION,
                payload: {
                    type: 'error',
                    text: t('general-error')
                }
            })
        })
    }
    return (
        <div className={classes.root} style={{width: isDesktop ? theme.maxContentWidth : '100%'}}>
            <SeoComp title={t('booking-system-supplier')} description={t('app-descp-supplier')} image={imageUrl}/>
            {editMode && <StyledStepper activeStep={activeStep} alternativeLabel={true} p={1}>
                {steps.map(({name: label, hide}, index) => {
                    const stepProps = {};
                    const labelProps = {};
                    if (hide) {
                        return <span key={label}></span>
                    }
                    return (
                        <Step key={label} {...stepProps} >
                            <StepLabel {...labelProps}>{label}</StepLabel>
                        </Step>
                    );
                })}
            </StyledStepper>}
            {activeStep === 0 && readyToRender &&
            <PersonalDetails onSubmit={handleNext} initialValues={initialValues} editMode={editMode}/>}
            {activeStep === 1 && readyToRender &&
            <ChooseProfession onSubmit={handleNext} initialValues={initialValues} handleBack={handleBack} editMode={editMode}/>}
            {activeStep === 2 && readyToRender &&<MoreDetails initialValues={initialValues} onSubmit={editMode ? handleNext : onSubmit} handleBack={handleBack} editMode={editMode}/>}
            {activeStep === 3 && readyToRender &&
            <DefineTimeOff onSubmit={onSubmit} handleBack={handleBack} initialValues={initialValues}/>}
            {activeStep === 4 && readyToRender && <div className={classes.successMessage}>
                <CheckCircleOutlineTwoToneIcon className={classes.bigGreenText}/>
                <span className={classes.bigGreenText}>{t('signed_up_success')}</span>
                <div className={classes.section}>
                    <CopyLinkToClipboard shortHash={shortHash}/>
                </div>
                <Link to={'/'}>
                    <Button variant='contained' color={'primary'}>
                        {t('go_to_diary')}
                    </Button>
                </Link>

            </div>}
        </div>
    );
}
const mapStateToProps = (state) => {
    return ({
    auth: state.general.auth,
    supplier: state.general.supplier
})}

const mapDispatchToProps = (dispatch) => ({
    dispatch,
    getSupplierData: getSupplierDataAction(dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(SighupSupplierWizard);